import { useCallback, useEffect } from "react";

type Args = {
  enable: boolean;
  containerElement: HTMLElement | null | undefined;
  closeFunction: () => void;
};

export const useClickOutside = ({
  enable,
  containerElement,
  closeFunction
}: Args) => {
  const handleClickOutside = useCallback(
    (e) => {
      if (enable && containerElement && !containerElement.contains(e.target)) {
        closeFunction();
      }
    },
    [closeFunction, containerElement, enable]
  );

  // close on click outside
  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [handleClickOutside]);
};
